<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <div style="position: relative">
        <v-btn
          v-if="readOnly"
          absolute
          fab
          top
          right
          dark
          color="primary"
          @click="editItem"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <br />
      <br />
      <form>
        <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <v-img
              v-if="instagram.foto_url_original"
              :src="instagram.foto_url"
              contain
              :key="instagram.fotoKey"
              max-height="300"
            ></v-img>
            <v-img
              v-else
              src="@/assets/empty_image.png"
              contain
              max-height="300"
            ></v-img>
            <v-file-input
              class="mt-4"
              outlined
              @change="loadImage"
              accept="image/*"
              v-model="instagram.poster_url"
              prepend-icon="mdi-image"
              show-size
              label="Gambar"
              :disabled="readOnly"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="Link Instagram"
                  required
                  v-model="instagram.link_instagram"
                  :readonly="readOnly"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="!readOnly">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn @click="doBatal" style="margin-right: 10px">Batal</v-btn>
            <v-btn dark color="primary" type="submit" @click.prevent="doSubmit"
              >Simpan</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </v-container>
  </v-main>
</template>

<script>
import InstagramService from "../../services/web_content/InstagramService";
import CommonService from "../../services/CommonService";

export default {
  name: "Instagram",
  components: {},
  props: {},
  data: () => ({
    breadcrumbs: [
      {
        text: "Instagram",
        disabled: false,
        exact: true,
        to: { name: "Instagram" },
      },
      { text: "Detail", disabled: true },
    ],
    readOnly: true,
    instagram: {
      id: null,
      foto_url_original: null,
      foto_url: null,
      fotoKey: 0,
      poster_url: null,
      link_instagram: "",
    },
  }),
  computed: {
    outlined() {
      return this.readOnly;
    },
    hideDetails() {
      return true;
    },
  },
  mounted: async function() {
    this.fetch();
  },
  methods: {
    loadImage: function(data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.instagram.foto_url = e.target.result;
          this.instagram.foto_url_original = this.instagram.foto_url;
          this.instagram.fotoKey++;
        };
        reader.readAsDataURL(data);
      }
    },
    fetch: async function() {
      try {
        console.log("fetch");
        InstagramService.getInstagram()
          .then((res) => {
            if (res.data.instagram) {
              this.instagram = res.data.instagram;
              console.log(this.instagram);
              console.log(this.instagram.id);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (e) {
        console.error("error:", e);
      }
    },

    editItem: async function() {
      this.readOnly = false;
    },

    doBatal: function() {
      this.readOnly = true;
    },

    doSubmit: async function() {
      try {
        console.log(this.instagram.id);
        if (this.instagram.id != null) {
          InstagramService.update(this.instagram)
            .then((res) => {
              console.log(res);
              CommonService.showSuccessToast("Update Instagram berhasil");

              this.fetch();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast("Update Instagram gagal. Coba lagi");
            });
        } else {
          InstagramService.create(this.instagram)
            .then((res) => {
              console.log(res);
              this.dialog = false;
              CommonService.showSuccessToast("Tambah Instagram berhasil");

              this.fetch();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast("Tambah Instagram gagal. Coba lagi");
            });
        }
      } catch (e) {
        console.error("error:", e);
      }
    },
  },
};
</script>

<style scoped></style>
